import React, { Fragment, useContext, useEffect } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import TableProvincesComponent from "./TableProvincesComponent";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import TableSearch from "../../../Shared/Components/Search/TableSearch";
import { hasPermission } from "../../../Shared/Utils/userUtils";
import ProvinceContext from "../Context/Index";
import { PlusCircle } from "react-feather";
import ProvinceForm from "./ProvinceForm";

export default function Index() {
  const { modalTogle, setItem, setSearchTerm } = useContext(ProvinceContext);
  const handleNew = () => {
    console.log("handleNew");

    setItem({});
    modalTogle();
  };
  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);
  return (
    <Fragment>
      <Breadcrumbs parent="Admin" title="Provincias" mainTitle="Provincias" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">{<TableSearch onSearch={setSearchTerm} />}</Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_list") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nueva provincia
                        </Btn>
                        <ProvinceForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <TableProvincesComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
